export const changeLanguage = (target, lang) => {
    return {
        type: "CHANGE_LANGUAGE",
        payload: lang
    }
}


// WEBPACK FOOTER //
// ./src/actions/actions-language.js